// extracted by mini-css-extract-plugin
module.exports = {"textWordWrap":"CommentList_textWordWrap_1Lsc0","btnTextStyle":"CommentList_btnTextStyle_1p7XL"};